<template>
    <div class="bg-0A1129 text-white min-vh-100">
        <!-- Main Header -->
        <Mainlayout />
    
        <div class="container-fluid pt-5">
            <br /> <br /> <br />
            <div class="row p-3">
    
                <div class="col-md-12">
                    <h3 class="custom-32px-700 text-center">Kursus FlyHigh</h3>
                    <h4 class="custom-24px-400 mb-3">Temukan pelbagai kursus yang sesuai dengan minat anda</h4>
                    <CCol sm="12" class="mt-5 text-center">
                        <CRow style="width:90%;margin:0 auto">
                            <CCol sm="10" class="p-0">
                                <div class="position-relative">
                                    <img src="../assets/img/search-normal.png" class="search-icon" />
                                    <CInput v-model="searchQuery" type="text" placeholder="Search..." class="custom-input-black pl-5" style="background:none;border:none" />
                                </div>
                            </CCol>
    
                            <CCol sm="2" class="p-0">
                                <CButton type="button" class="bg-1796FD text-white ml-2 mt-2" @click="applySearch">Cari</CButton>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CRow>
                        <CCol sm="12">
                            <div class="row" style="width:90%;margin:0 auto">
    
                                <div class="col-md" v-for="grade in grades" :key="grade.Id">
    
    
                                    <v-select v-model="selectedByGrade[grade.Id]" :options="[{ Id: 'all', Name: 'All Categories' }, ...(subgradesByGrade[grade.Id] || [])]" label="Name" :reduce="option => option.Id" :placeholder="grade.Name" class="custom-input-black-select" @search:focus="fetchSubgrades(grade.Id)"
                                        clearable @input="handleSelect(grade.Id)" />
    
                                </div>
                            </div>
                        </CCol>
                    </CRow>
                    <h4 class="mb-3 mt-5">Sedang Promosi!</h4>
    
                    <div class="row">
                        <div class="col-md-4 mb-4" v-for="(course, index) in filteredCourses" :key="index">
                            <div class="border-card-black text-dark border-24px p-0">
                                <div class="p-0">
                                    <div class="text-center position-relative">
                                        <!-- Fullscreen icon (clickable) -->
                                        <img src="../assets/img/fullscreen.png" width="30px" style="position: absolute; top: 10px; right: 10px; cursor: pointer; z-index: 2;" @click="openImagePopup(course.PicturePath)" />
    
                                        <!-- Course image -->
                                        <img :src="course.PicturePath" alt="Course Image" class="card-img-top border-half-24px" style="width: 100%; height: auto; object-fit: contain;" @click="openImagePopup(course.PicturePath)" />
                                    </div>
    
                                </div>
    
                                <div class="pl-3">
                                    <h5 class="text-white mt-2">{{ course.Title }} (x{{ course.Quantity || 1 }})</h5>
                                    <h3 class="custom-16px-400 text-white">{{ course.DateCourse |moment("DD MMM") }} - 08.00 PM</h3>
                                    <p>
                                        <template v-if="course.Discount > 0">
                                                                        <del class="font-color-1796FD custom-18px-500">RM {{ course.Price }}</del>
                                                                        <strong class="text-white custom-18px-600">
                                                                        RM {{ (course.Price - course.Discount) * (course.Quantity || 1) }}
                                                                        </strong>
</template>

<template v-else>
    <strong class="text-white custom-18px-600">
                                                                        RM {{ course.Price * (course.Quantity || 1) }}
                                                                        </strong>
</template>
                                        </p>
    
    
                                </div>
                                <div style="clear:both"></div>
                                <CCol sm="12" class="mb-2">
                                    <CRow>
                                        <CCol sm="8" v-if="course.TotalBuying > 0">
                                            <h3 class="custom-16px-600 text-white">
                                                {{ course.TotalBuying }} students purchased
                                            </h3>
                                            </CCol>
                                        <CCol sm="4">
                                            <CButton class="bg-1796FD custom-padding text-white" style="border-radius:50px" @click="GoToDetail(course)">
                                               Info Lanjut
                                            </CButton>
    
                                        </CCol>
                                    </CRow>
                                </CCol>
    
    
    
                            </div>
                        </div>
                    </div>
                </div>
    
    
    
            </div>
        </div>

        <div v-if="showImagePopup" class="image-popup-backdrop" @click.self="closeImagePopup">
  <div class="image-popup-content">
    <img :src="popupImageSrc" class="img-fluid" style="max-height: 90vh;" />
    <button class="close-button-popup" @click="closeImagePopup">X</button>
  </div>
</div>
    
        <!-- Footer -->
        <Footer />
    </div>
</template>
  
<script>
import Vue from "vue";
Vue.use(Carousel3d);
import Mainlayout from "@/containers/AllHeader.vue";
import Footer from "@/components/Footer.vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import ToggleCard from '../components/Toggle.vue';
Vue.use(require("vue-moment"));
Vue.use(require("moment"));
var moment = require("moment");

export default {
    name: "FlyHighHome",
    components: {
        Mainlayout,
        Footer,
        Carousel3d,
        Slide,
        moment

    },
    async mounted() {


        this.GetListPackage();


        this.ListDataGrade();


    },
    data() {
        return {
            step: 1,
            courses: [],
            banners: [
                { src: require('@/assets/img/flyhigh/banner1.png') },
                { src: require('@/assets/img/flyhigh/banner2.png') },
            ],
            isProductOpen: false,
            grade: [],
            isJenisOpen: true,
            isStandardOpen: true,
            isSubjekOpen: true,
            selectedType: 'combo',
            showFilterOptions: false,
            selectedCourses: [],
            showImagePopup: false,
            popupImageSrc: "",
            productsByGrade: {}, // grouped data
            selectedByGrade: {}, // track selected product for each grade
            groupedByGrade: {},

            subdatagradeByGrade: {},
            subgrade: [],


            gradeList: [], // keeps track of selection per grade
            subgradesByGrade: {},
            grades: [],
            searchQuery: "",
        };

    },
    computed: {
        sliderStyle() {
            let slidesPerView = 1; // Default for mobile

            if (window.innerWidth >= 768 && window.innerWidth < 1024) {
                slidesPerView = 2; // Tablet (2 per slide)
            } else if (window.innerWidth >= 1024) {
                slidesPerView = 2; // Desktop (3 per slide)
            }

            return {
                transform: `translateX(-${(this.step - 1) * (100 / slidesPerView)}%)`,
                transition: 'transform 0.5s ease-in-out'
            };
        },

        uniqueGrades() {
            let grades = [];
            this.courses.forEach(c => {
                c.GradeClasses.forEach(gc => {
                    if (gc.Grade && !grades.includes(gc.Grade)) {
                        grades.push(gc.Grade);
                    }
                });
            });
            return grades;
        },
        // subgrades ikut grade yang dipilih
        availableSubGrades() {
            if (!this.selectedGrade) return [];
            let subgrades = [];
            this.courses.forEach(c => {
                c.GradeClasses.forEach(gc => {
                    if (gc.Grade === this.selectedGrade && !subgrades.includes(gc.SubGradeName)) {
                        subgrades.push(gc.SubGradeName);
                    }
                });
            });
            return subgrades;
        },
        filteredCourses() {
            let result = this.courses;

            // Loop through selectedByGrade
            Object.entries(this.selectedByGrade).forEach(([gradeId, subId]) => {
                const gradeObj = this.grades.find(g => g.Id === Number(gradeId));
                if (!gradeObj) return;

                if (subId === "all") {
                    // Filter all courses for this grade only
                    result = result.filter(course =>
                        course.GradeClasses.some(gc => gc.Grade === gradeObj.Name)
                    );
                } else if (subId) {
                    // Filter by specific subgrade
                    result = result.filter(course =>
                        course.GradeClasses.some(gc => {
                            const subgradeList = this.subgradesByGrade[gradeId] || [];
                            const subObj = subgradeList.find(sg => sg.Id === subId);
                            return gc.Grade === gradeObj.Name && gc.SubGradeName === (subObj ? subObj.Name : null);
                        })
                    );
                }
            });

            // Apply search filter
            if (this.searchQuery && this.searchQuery.trim()) {
                const q = this.searchQuery.toLowerCase();
                result = result.filter(course =>
                    (course.Title && course.Title.toLowerCase().includes(q)) ||
                    (course.Code && course.Code.toLowerCase().includes(q)) ||
                    (course.Description && course.Description.toLowerCase().includes(q))
                );
            }
            return result;
        }
    },

    methods: {

        nextSlide() {
            if (this.step < this.banners.length) {
                this.step++;
            }
        },
        prevSlide() {
            if (this.step > 1) {
                this.step--;
            }
        },
        goToStep(index) {
            this.step = index;
        },
        toggleProductList() {
            this.isProductOpen = !this.isProductOpen;
        },
        // GoToDetail() {
        //     this.$router.push("DetailProduct");
        // },
        toggleJenisList() {
            this.isJenisOpen = !this.isJenisOpen;
        },
        toggleStandardList() {
            this.isStandardOpen = !this.isStandardOpen;
        },
        toggleSubjekList() {
            this.isSubjekOpen = !this.isSubjekOpen;
        },
        toggleFilterOptions() {
            this.showFilterOptions = !this.showFilterOptions;
        },
        GetListPackage() {
            this.$API
                .get(this.$GetListProduct)
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.courses = response.data;
                    }
                });
        },
        // GoToDetail(course) {
        //     if (!course || !course.Title) {
        //         console.warn("Invalid course clicked:", course);
        //         return;
        //     }

        //     let cartItem = {
        //         ID: course.ID,
        //         Title: course.Title,
        //         PicturePath: course.PicturePath,
        //         Price: course.Price,
        //         Discount: course.Discount,
        //     };

        //     let existing = JSON.parse(localStorage.getItem("cartItems")) || [];

        //     let found = existing.find(item => item.ID === course.ID);
        //     if (found) {
        //     found.Quantity = (found.Quantity || 1) + 1;
        //     } else {
        //     existing.push({
        //         ID: course.ID,
        //         Title: course.Title,
        //         PicturePath: course.PicturePath,
        //         Price: course.Price,
        //         Discount: course.Discount,
        //         Quantity: 1
        //     });
        //     }

        //     localStorage.setItem("cartItems", JSON.stringify(existing));
        //     this.$router.push("DetailProduct");
        // },
        GoToDetail(course) {
            if (!course || !course.ID) {
                alert("Invalid course");
                return;
            }

            // ✅ Save selected course
            this.selectedCourses = [course];
            localStorage.setItem("selectedCourses", JSON.stringify(this.selectedCourses));

            // ✅ Get affiliate code from query param if exists
            const affCode = this.$route.query.aff;

            if (affCode) {
                // Pass as query param to DetailProduct
                this.$router.push({
                path: `/DetailProduct/${course.ID}`,
                query: { aff: affCode }
                });
            } else {
                this.$router.push(`/DetailProduct/${course.ID}`);
            }
        },
        openImagePopup(imageUrl) {
            this.popupImageSrc = imageUrl;
            this.showImagePopup = true;
        },
        closeImagePopup() {
            this.showImagePopup = false;
            this.popupImageSrc = "";
        },
        ListDataGrade() {
            this.$API
                .get(this.$GetListGradePackage)
                .then((response) => {
                    if (response.status === 200 && response.data) {
                        this.grades = response.data; // ✅ grades are objects now
                    }
                })
                .catch((err) => {
                    console.error("Error fetching grades:", err);
                });
        },

        ListSubDataGrade(gradeId) {
            this.$API
                .get(this.$GetListSubGradePackage + "?gradeId=" + gradeId)
                .then((response) => {
                    if (response.status === 200 && response.data) {
                        this.$set(this.subgradesByGrade, gradeId, response.data);
                    }
                })
                .catch((err) => {
                    console.error("Error fetching subgrades:", err);
                });
        },
        fetchSubgrades(gradeId) {
            this.$API
                .get(this.$GetListSubGradePackage + "?gradeId=" + gradeId)
                .then((response) => {
                    if (response.status == 200 && response.data) {
                        this.$set(this.subgradesByGrade, gradeId, response.data);
                    }
                })
                .catch(err => console.error("Error fetching subgrades:", err));
        },
        handleSelect(selectedGradeId) {
            let selected = this.selectedByGrade[selectedGradeId];

            // 🔹 If cleared (null/empty), set back to "all"
            if (!selected) {
                this.$set(this.selectedByGrade, selectedGradeId, "all");
                selected = "all";
            }

            // 🔹 Optional: clear other dropdowns if one is chosen
            Object.keys(this.selectedByGrade).forEach(id => {
                if (parseInt(id) !== selectedGradeId) {
                    this.$set(this.selectedByGrade, id, "");
                }
            });

            console.log("Selected for grade:", selectedGradeId, selected);
        },
        applySearch() {
            // force recompute (computed already reactive, but button is optional)
            this.searchQuery = this.searchQuery.trim();
        }
    }
}
</script>
  
<style scoped>
.vs__placeholder {
    color: #ffffff;
    /* white */
    opacity: 1;
    /* be sure it’s fully opaque */
}

.vs__search,
.vs__search:focus {
    color: #fff;
}

.vs__search::placeholder {
    color: #ffffff;
    /* white */
    opacity: 1;
}

.slider-wrapper {
    overflow: hidden;
    width: 100%;
}

.slider {
    display: flex;
    transition: transform 0.5s ease-in-out;
    white-space: nowrap;
    align-items: stretch;
    /* Ensures all slides have the same height */
}

.slide::before {
    display: none !important;
}

.slide {
    min-width: 100%;
    padding: 10px;
    transition: opacity 0.5s, transform 0.5s;
    height: 100%;
    /* Ensure all slides remain the same height */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 10;
    opacity: 1 !important;
}

@media (min-width: 1024px) {
    .slide {
        min-width: calc(100% / 3);
        /* Each slide takes 1/3 of the container */
    }
}

@media (min-width: 768px) and (max-width: 1023px) {
    .slide {
        min-width: 50%;
        /* Show 2 items per slide */
    }
}

.active-slide {
    opacity: 1;
    transform: scale(1);
    /* Ensure the active slide does not change in size */
}

.slide:not(.active-slide) {
    opacity: 0.6;
    /* Dim non-active slides */
    transform: scale(1);
    /* Keep all slides the same size */
}

.image-container {
    position: relative;
    width: 100%;
    height: 100%;
    /* Ensure the image container takes full height */
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.onboarding-image {
    width: 100%;
    /* Make all images the same height */
    border-radius: 10px;
    object-fit: cover;
    /* Ensures the image maintains proportion */
}

.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* Dark overlay */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 20px;
    border-radius: 10px;
    color: white;
}

.pagination {
    display: flex;
    justify-content: center;
    gap: 5px;
}

.pagination span {
    width: 10px;
    height: 10px;
    background: #ccc;
    border-radius: 50%;
    cursor: pointer;
    transition: background 0.3s;
}

.pagination span.active {
    background: #fff;
}

.nav-arrow {
    position: absolute;
    top: 17%;
    transform: translateY(-50%);
    background-color: rgba(0, 0, 0, 0.4);
    color: white;
    font-size: 1.2rem;
    /* smaller font size */
    border: none;
    cursor: pointer;
    z-index: 10;
    padding: 0.3rem 0.6rem;
    /* smaller padding */
    border-radius: 50%;
    width: 30px;
    height: 30px;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.left-arrow {
    left: 10px;
}

.right-arrow {
    right: 10px;
}

.nav-arrow:hover {
    background-color: rgba(0, 0, 0, 0.6);
}

.list-group-item {
    transition: all 0.3s;
}

.toggle-icon {
    width: 20px;
    height: 20px;
}

.list-group-item img {
    width: 18px;
    height: 18px;
}

.custom-select {
    width: 100%;
    border-radius: 16px;
    background-color: #2b2e3f;
    /* dark background */
    color: #ffffff;
    /* text white */
    border: none;
    outline: none;
    appearance: none;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.custom-select option {
    background-color: #2b2e3f;
    /* dropdown bg */
    color: #ffffff;
    padding: 5px;
}

.custom-select:hover {
    background-color: #3c4052;
    /* hover color */
}

.custom-select:focus {
    outline: none;
    box-shadow: 0 0 0 2px #4f46e5;
    /* optional focus border */
}

select {
    appearance: none;
    border-radius: 16px;
    padding: 8px;
}

.custom-vselect {
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.1) !important;
    font-size: 13px;
    font-weight: 700;
    line-height: 18px;
    border: none;
    height: 52px;
}

/* .v-select .vs__placeholder,
.v-select .vs__selected {
  color: #fff !important;
}

::v-deep(.vs__open-indicator) {
  fill: #fff !important;
  stroke: #fff !important;
}

::v-deep(.vs__clear svg path) {
  fill: #fff !important;
  stroke: #fff !important;
} */
</style>